/**
 * Centralized HTTP configuration shared by all Axios instances.
 *
 * - getApiBaseUrl()        – resolves the backend URL for any environment
 */

// ── Base URL ────────────────────────────────────────────────────────────────

export const getApiBaseUrl = (): string => {
  if (process.env.NODE_ENV === 'production') {
    return process.env.REACT_APP_BACKEND_URL || 'https://api.drimrun.mk';
  }

  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';

  // In remote dev hosts, use CRA proxy (/api and /uploads) to avoid CORS and
  // private-port accessibility issues. This stays dev-only by design.
  if (
    hostname.endsWith('.app.github.dev') ||
    hostname.endsWith('.github.dev') ||
    hostname.endsWith('.gitpod.io')
  ) {
    return '';
  }

  return (
    process.env.REACT_APP_BACKEND_URL ||
    'http://localhost:5000'
  );
};
